import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// True when the page loaded via a password-reset link.
// Cleared on USER_UPDATED so normal sign-in works after reset.
let _recoveryMode =
  typeof window !== 'undefined' && window.location.hash.includes('type=recovery')

export const recoveryMode = { get value() { return _recoveryMode } }
export const clearRecoveryMode = () => { _recoveryMode = false }
